import {
	PRODUCT_EXPIRY_DATE_POLICY,
	PRODUCT_EXPIRY_DATE_POLICY_NAME,
} from '../../constants';

export const resolveProductExpiryDatePolicy = ({
	product,
	tenantSettings,
} = {}) => {
	if (tenantSettings && !tenantSettings.useExpiryDates) {
		return PRODUCT_EXPIRY_DATE_POLICY.OPTIONAL;
	}

	if (tenantSettings?.requireFreshFoodExpiryDates && product?.isFreshFood) {
		return PRODUCT_EXPIRY_DATE_POLICY.REQUIRED;
	}

	return product?.expiryDatePolicy || PRODUCT_EXPIRY_DATE_POLICY.OPTIONAL;
};

export const isProductExpiryDateRequired = ({
	product,
	tenantSettings,
} = {}) => {
	return resolveProductExpiryDatePolicy({ product, tenantSettings }) === PRODUCT_EXPIRY_DATE_POLICY.REQUIRED;
};

export const isProductExpiryDateRecommended = ({
	product,
	tenantSettings,
} = {}) => {
	return resolveProductExpiryDatePolicy({ product, tenantSettings }) === PRODUCT_EXPIRY_DATE_POLICY.RECOMMENDED;
};

export const shouldPromptForProductExpiryDate = ({
	product,
	tenantSettings,
} = {}) => {
	const policy = resolveProductExpiryDatePolicy({ product, tenantSettings });
	return policy === PRODUCT_EXPIRY_DATE_POLICY.REQUIRED || policy === PRODUCT_EXPIRY_DATE_POLICY.RECOMMENDED;
};

export const getProductExpiryDatePolicyName = (policy) => {
	return PRODUCT_EXPIRY_DATE_POLICY_NAME[policy || PRODUCT_EXPIRY_DATE_POLICY.OPTIONAL] || PRODUCT_EXPIRY_DATE_POLICY_NAME[PRODUCT_EXPIRY_DATE_POLICY.OPTIONAL];
};
